import {Button, Menu, MenuItem, Tabs, Tab} from '@mui/material'
import {useEffect, useState} from 'react'
import WbTabPanel from '../../../../components/common/WbTabPanel'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import surveyQuestionApi from '../../../../services/api/surveys/surveyQuestionApi'
import Questions from './Questions'
import {
  buildExportRows,
  buildPdfSections,
  downloadCsv,
  downloadExcel,
  downloadStyledPdf,
} from './questionExportUtils'

export default function SurveyQuestions({survey}) {
  const [audience, setAudience] = useState([])
  const [tab, setTab] = useState(0)
  const [questions, setQuestions] = useState([])
  const [downloadAnchor, setDownloadAnchor] = useState(null)

  useEffect(() => {
    let a = []
    if (survey) {
      if (
        survey.audience === 1 ||
        survey.audience === 3 ||
        survey.audience === 5 ||
        survey.audience === 7
      ) {
        a.push({value: 1, label: 'Staff'})
      }
      if (
        survey.audience === 2 ||
        survey.audience === 3 ||
        survey.audience === 6 ||
        survey.audience === 7
      ) {
        a.push({value: 2, label: 'Parent'})
      }
      if (
        survey.audience === 4 ||
        survey.audience === 5 ||
        survey.audience === 6 ||
        survey.audience === 7
      ) {
        a.push({value: 4, label: 'Student'})
      }
      setAudience([...a])
      a.length > 0 && setTab(a[0].value)
    }
    surveyQuestionApi.getByToken(survey.token).then(res => {
      setQuestions(res)
    })
  }, [survey])

  const getFileBaseName = () => {
    const surveyName = survey?.name || 'survey-questions'
    return String(surveyName)
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .toLowerCase()
  }

  const handleDownload = type => {
    const rows = buildExportRows({questions, audiences: audience})
    const fileBaseName = `${getFileBaseName()}-questions`

    if (type === 'csv') {
      downloadCsv({rows, fileBaseName})
    } else if (type === 'xlsx') {
      downloadExcel({rows, fileBaseName})
    } else if (type === 'pdf') {
      const sections = buildPdfSections({questions, audiences: audience})
      downloadStyledPdf({
        sections,
        fileBaseName,
        surveyName: survey?.name || 'Survey Questions',
      })
    }
    setDownloadAnchor(null)
  }

  const renderDownload = () => (
    <div style={{display: 'flex', justifyContent: 'flex-end', marginBottom: 8}}>
      <Button
        variant="outlined"
        size="small"
        endIcon={<KeyboardArrowDownIcon />}
        disabled={questions.length === 0 || audience.length === 0}
        onClick={e => setDownloadAnchor(e.currentTarget)}
      >
        Download
      </Button>
      <Menu
        anchorEl={downloadAnchor}
        open={Boolean(downloadAnchor)}
        onClose={() => setDownloadAnchor(null)}
      >
        <MenuItem onClick={() => handleDownload('csv')}>Download CSV</MenuItem>
        <MenuItem onClick={() => handleDownload('xlsx')}>Download Excel</MenuItem>
        <MenuItem onClick={() => handleDownload('pdf')}>Download PDF</MenuItem>
      </Menu>
    </div>
  )

  const renderTabs = () => (
    <Tabs value={tab} onChange={(e, val) => setTab(val)} className="questions-tabs">
      {audience.map(aud => (
        <Tab key={aud.value} label={aud.label} value={aud.value} />
      ))}
    </Tabs>
  )
  const renderTabPanels = () =>
    audience.map(aud => (
      <WbTabPanel key={aud.value} value={tab} index={aud.value}>
        <Questions audience={aud} questions={questions} />
      </WbTabPanel>
    ))
  // const renderDownload = () => (
  //   <div className='download-questions'>
  //     Download all questions
  //     <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  //       <path d="M23.3334 15.1667V12.4331C23.3334 11.4793 23.3334 11.0024 23.1558 10.5736C22.9782 10.1448 22.641 9.80761 21.9665 9.13321L16.4406 3.60723C15.8586 3.02521 15.5676 2.73418 15.207 2.56175C15.132 2.52587 15.0552 2.49405 14.9768 2.46639C14.5999 2.33337 14.1884 2.33337 13.3652 2.33337C9.57937 2.33337 7.68644 2.33337 6.4043 3.36712C6.14528 3.57597 5.90934 3.8119 5.7005 4.07093C4.66675 5.35307 4.66675 7.246 4.66675 11.0319V15.1667M15.1667 2.91671V3.50004C15.1667 6.79988 15.1667 8.44979 16.1919 9.47491C17.217 10.5 18.8669 10.5 22.1667 10.5H22.7501" stroke="#E84F6B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  //       <path d="M23.0416 18.6666H20.1249C19.4806 18.6666 18.9583 19.1889 18.9583 19.8333V22.1666M18.9583 22.1666V25.6666M18.9583 22.1666H22.4583M4.95825 25.6666V22.75M4.95825 22.75V18.6666H6.99992C8.1275 18.6666 9.04159 19.5807 9.04159 20.7083C9.04159 21.8359 8.1275 22.75 6.99992 22.75H4.95825ZM11.9583 18.6666H13.7083C14.997 18.6666 16.0416 19.7113 16.0416 21V23.3333C16.0416 24.622 14.997 25.6666 13.7083 25.6666H11.9583V18.6666Z" stroke="#E84F6B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  //     </svg>
  //   </div>
  // )

  return (
    <>
      {renderDownload()}
      {renderTabs()}
      {renderTabPanels()}
    </>
  )
}
